exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cancel-btn[data-v-1a3306fb]{background-color:#d33 !important;color:#fff !important;font-size:1.1em\n}\n.cancel-btn[data-v-1a3306fb] :hover{background-color:#d33 !important\n}\n.btn-container[data-v-1a3306fb]{display:flex;justify-content:end;margin-top:20px\n}\n.data-container[data-v-1a3306fb]{display:flex;justify-content:start;gap:0 20px\n}\n.video-duration[data-v-1a3306fb]{font-size:.85rem;color:#757575;font-weight:normal;margin-top:8px\n}\n.playlists-container[data-v-1a3306fb]{margin:15px 0;padding:10px 0;border-top:1px solid rgba(153,155,155,.2)\n}\n.playlists-container .md-subheading[data-v-1a3306fb]{margin-bottom:5px;font-weight:600\n}\n.playlist-names[data-v-1a3306fb]{font-size:.9rem;color:#616161;margin:0;line-height:1.5\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-1a3306fb","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/mediaItem/RentalPriceDialog.vue
// module id = 188
// module chunks = 0